<script lang="ts" setup>
import { homeConfig as rocnovelConfig } from './configs/rocnovel'
import { homeConfig as ocereadConfig } from './configs/oceread'
import { homeConfig as talewaveConfig } from './configs/talewave'
import { homeConfig as ficmoonConfig } from './configs/ficmoon'
import { homeConfig as novelarcConfig } from './configs/novelarc'
import { homeConfig as storyellaConfig } from './configs/storyella'
import { homeConfig as florastoryConfig } from './configs/florastory'
import { homeConfig as silktaleConfig } from './configs/silktale'
import { homeConfig as pearlaConfig } from './configs/pearla'
import { homeConfig as fictoraConfig } from './configs/fictora'
import { homeConfig as marinovelConfig } from './configs/marinovel'
import { homeConfig as flipnovelConfig } from './configs/flipnovel'
import { homeConfig as moonpageConfig } from './configs/moonpage'
import { homeConfig as storlynConfig } from './configs/storlyn'
import { homeConfig as novarisConfig } from './configs/novaris'
import { useHomePage } from './composables/useHomePage'
import HomePageDefault from './components/HomePage.default.vue'
import HomePageFicmoon from './components/HomePage.ficmoon.vue'
import HomePageNovelarc from './components/HomePage.novelarc.vue'
import HomePageFlipnovel from './components/HomePage.flipnovel.vue'
import HomePageStorlyn from './components/HomePage.storlyn.vue'
import HomePageTalewave from './components/HomePage.talewave.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  talewave: talewaveConfig,
  ficmoon: ficmoonConfig,
  novelarc: novelarcConfig,
  storyella: storyellaConfig,
  florastory: florastoryConfig,
  silktale: silktaleConfig,
  pearla: pearlaConfig,
  fictora: fictoraConfig,
  marinovel: marinovelConfig,
  flipnovel: flipnovelConfig,
  moonpage: moonpageConfig,
  storlyn: storlynConfig,
  novaris: novarisConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const HomePage = loadBrandComponent({
  rocnovel: HomePageDefault,
  oceread: HomePageDefault,
  ficmoon: HomePageFicmoon,
  novelarc: HomePageNovelarc,
  storyella: HomePageNovelarc,
  florastory: HomePageNovelarc,
  silktale: HomePageNovelarc,
  pearla: HomePageNovelarc,
  fictora: HomePageFicmoon,
  marinovel: HomePageDefault,
  talewave: HomePageTalewave,
  flipnovel: HomePageFlipnovel,
  moonpage: HomePageFlipnovel,
  storlyn: HomePageStorlyn,
  novaris: HomePageStorlyn,
})

// 🔥 使用 composable 管理页面逻辑
const {
  setInfiniteRef,
  input,
  inputFocused,
  pageList,
  pageInfo,
  skeleton,
  modules,
  currentTagId,
  feeds,
  feedShowName,
  feedId,
  feedsColumnType,
  feedFetching,
  feedEnding,
  homeBgUrl,
  switchNavTrack,
  onSearch,
  gotoCollection,
  gotoTags,
  gotoBook,
  getCurrentTagResources,
  getCurrentShowTags,
  handleTagClick,
  setInputRef,
} = useHomePage(config)
</script>

<template>
  <HomePage
    :config="config"
    :set-infinite-ref="setInfiniteRef"
    :set-input-ref="setInputRef"
    :input="input"
    :input-focused="inputFocused"
    :page-list="pageList"
    :page-info="pageInfo"
    :skeleton="skeleton"
    :modules="modules"
    :current-tag-id="currentTagId"
    :feeds="feeds"
    :feed-show-name="feedShowName"
    :feed-id="feedId"
    :feeds-column-type="feedsColumnType"
    :feed-fetching="feedFetching"
    :feed-ending="feedEnding"
    :home-bg-url="homeBgUrl"
    :switch-nav-track="switchNavTrack"
    :on-search="onSearch"
    :goto-collection="gotoCollection"
    :goto-tags="gotoTags"
    :goto-book="gotoBook"
    :get-current-tag-resources="getCurrentTagResources"
    :get-current-show-tags="getCurrentShowTags"
    :handle-tag-click="handleTagClick"
    @update:input="input = $event"
  />
</template>
